// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCreateSiteResultModel {
    static getAttributeTypeMap() {
        return EnrollmentCreateSiteResultModel.attributeTypeMap;
    }
}
EnrollmentCreateSiteResultModel.discriminator = undefined;
EnrollmentCreateSiteResultModel.attributeTypeMap = [
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "string"
    },
    {
        "name": "siteVerified",
        "baseName": "siteVerified",
        "type": "boolean"
    },
    {
        "name": "createDate",
        "baseName": "createDate",
        "type": "Date"
    },
    {
        "name": "lastUpdateDate",
        "baseName": "lastUpdateDate",
        "type": "Date"
    }
];
//# sourceMappingURL=enrollmentCreateSiteResultModel.js.map